// @flow

import React, { type Node } from 'react';

type Props = {|
  +children: Node,
|};

export function UberV2Page({ children }: Props): Node {
  return (
    <>
      <link
        href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700"
        rel="stylesheet"
      />
      {children}
    </>
  );
}
